// extracted by mini-css-extract-plugin
export default {"banner":"CookiesBanner-module--banner--ISamT"};